import React from "react";
import { useBuilder, BlockConfig } from "../BuilderContext";

const RecipientBlock: React.FC<{ block: BlockConfig }> = ({ block }) => {
  const { state } = useBuilder();
  const heading = block.settings.headingOverride || "Bill To";
  const client = state.client;
  if (!client) return null;

  const email = client.emails?.[0]?.email;
  const addr = client.addresses?.[0];
  const phone = client.phones?.[0]?.number;

  return (
    <div className="py-4">
      <p className="text-xs font-semibold text-slate-400 uppercase tracking-wide mb-2">{heading}</p>
      <p className="text-sm font-bold text-slate-800">{client.displayName}</p>
      {addr && (
        <div className="text-xs text-slate-600 mt-1">
          {addr.line1 && <p>{addr.line1}</p>}
          {addr.city && (
            <p>
              {addr.city}
              {addr.region ? `, ${addr.region}` : ""}
              {addr.postal ? ` ${addr.postal}` : ""}
            </p>
          )}
        </div>
      )}
      {email && <p className="text-xs text-slate-500 mt-1">{email}</p>}
      {phone && <p className="text-xs text-slate-500">{phone}</p>}
    </div>
  );
};

export default RecipientBlock;
